module.exports = __webpack_public_path__ + "img/partners.a5bc53f1.svg";